import { GameUI } from './ui/GameUI';
import { MultiplayerUI } from './ui/MultiPlayerUI_new';
import './ui/MultiplayerUI.css';
import './styles/screens.css';

// Check URL parameter for mode
const urlParams = new URLSearchParams(window.location.search);
const mode = urlParams.get('mode') || 'multiplayer'; // Default to multiplayer

// Initialize the appropriate UI when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector<HTMLElement>('#app');
  if (!container) return;

  if (mode === 'single') {
    // Single player mode
    new GameUI('#app');
  } else {
    // Multiplayer mode
    container.innerHTML = '';
    new MultiplayerUI(container);
  }
});
